// MobileBackButton.js
import React from 'react';
import { Button } from 'react-bootstrap';
import { CaretLeftFill } from 'react-bootstrap-icons';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { useLocation } from 'react-router-dom';
import './MobileBackButton.css';

// Routes where BottomNavbar hides the search bar. With no search row above the
// nav, the back button drops into the freed space (see the
// .mobile-back-button--no-search rule). Keep this list in sync with
// SEARCHLESS_ROUTES in BottomNavbar.js.
const SEARCHLESS_ROUTES = ['/fact-check', '/social'];

const MobileBackButton = () => {
  const location = useLocation();
  const searchHidden = SEARCHLESS_ROUTES.includes(location.pathname);

  // Federal / State / Province / Kingdom / Local are peer tabs, not a drill-in,
  // so there is nothing meaningful to go "back" to from them. The level
  // switcher in IntegratedSearchNavBar tags the history entries it creates with
  // fromLevelSwitcher; React Router keeps that flag on the entry itself, so it
  // still reads true when the user returns to the entry via the OS back gesture
  // or the browser's own back button.
  const fromLevelSwitcher = location.state?.fromLevelSwitcher === true;

  const handleHapticsClick = async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      console.warn('Haptics not available:', error);
    }
    window.history.back();
  };

  if (fromLevelSwitcher) return null;

  return (
    <Button 
      className={`mobile-back-button${searchHidden ? ' mobile-back-button--no-search' : ''}`}
      onClick={(e) => {
        e.preventDefault();
        handleHapticsClick();
      }}
    >
      <CaretLeftFill size={30} className="mobile-back-icon" />
    </Button>
  );
};

export default MobileBackButton;